<template>
  <div>
    <input
      ref="questionInput"
      class="form-control"
      :type="choice.is_custom === true ? 'text' : 'number'"
      :inputmode="choice.is_custom === true ? 'text' : 'numeric'"
      :min="choice.is_custom !== true && 0"
      :placeholder="placeholder"
      @input="updateInput(choice, $event)"
      @update:model-value="updateTextModel"
      :value="textValue"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  props: {
    choice: {
      type: Object,
      default: () => {},
      required: true
    },
    placeholder: {
      type: String,
      default: '',
      required: true
    },
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      textValue: this.value
    }
  },
  emits: ['update:value', 'updateQuestionInput'],
  mounted() {
    if (this.choice.is_custom !== true) {
      this.$refs.questionInput.setAttribute('oninput', "validity.valid||(value='')")
    }
  },
  methods: {
    updateTextModel(updatedTextValue) {
      this.textValue = updatedTextValue
      this.$emit('update:value', updatedTextValue)
    },
    updateInput(choice, event) {
      this.$emit('updateQuestionInput', choice, event)
    }
  }
}
</script>

<style></style>
